<section class="card">
  <header class="fraud-panel-heading">
    <h2>شواهد مقایسه حرکت</h2>
    <span class="muted">بازه‌های دارای داده ناکافی، شواهد قطعی نیستند.</span>
  </header>
  <div class="body fraud-state-body">
    <div *ngIf="loading" class="loader show"><div class="spinner"></div><span>در حال دریافت شواهد...</span></div>
    <div *ngIf="!loading && error" class="state show error">
      <i class="fa fa-exclamation-triangle ico-big" aria-hidden="true"></i>
      <p>{{ error }}</p>
      <button class="btn btn-ghost" type="button" (click)="retry.emit()">تلاش دوباره</button>
    </div>
    <div *ngIf="!loading && !error && !items.length" class="state show">
      <i class="fa fa-list-alt ico-big" aria-hidden="true"></i><p>شواهدی برای این پرونده ثبت نشده است.</p>
    </div>
    <div *ngIf="!loading && !error && items.length" class="table-scroll">
      <table>
        <thead><tr>
          <th>بازه زمانی</th><th>ارزیابی</th><th>امتیاز شباهت</th><th>میانگین فاصله</th><th>حداکثر فاصله</th>
          <th>اختلاف سرعت</th><th>اختلاف جهت</th><th>دقایق مشترک</th><th>تعداد مقایسه</th>
        </tr></thead>
        <tbody class="still">
          <tr *ngFor="let item of items">
            <td><bdi dir="ltr">{{ item.timeRange | faNum }}</bdi></td>
            <td><span class="tag" [ngClass]="item.evaluationClass">{{ item.evaluationLabel }}</span></td>
            <td>{{ (item.fSimilarityScore | number:'1.2-2') ?? '—' | faNum }}</td>
            <td>{{ (item.fAverageDistance | number:'1.2-2') ?? '—' | faNum }} متر</td>
            <td>{{ (item.fMaxDistance | number:'1.2-2') ?? '—' | faNum }} متر</td>
            <td>{{ (item.fAverageSpeedDifference | number:'1.2-2') ?? '—' | faNum }}</td>
            <td>{{ (item.fAverageHeadingDifference | number:'1.2-2') ?? '—' | faNum }}°</td>
            <td>{{ item.iMatchedMinutes | number | faNum }}</td>
            <td>{{ item.iComparedRecords | number | faNum }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
